import {
    JOBSPOT_LIST_PENDING,
    JOBSPOT_LIST_SUCCESS,
    JOBSPOT_LIST_ERROR,
    DELETE_JOBSPOT_SUCCESS,
    DELETE_JOBSPOT_ERROR,
    DELETE_JOBSPOT_PENDING,
    ADD_JOBSPOT_SUCCESS,
    ADD_JOBSPOT_ERROR,
    ADD_JOBSPOT_PENDING,
    EDIT_JOBSPOT_SUCCESS,
    EDIT_JOBSPOT_ERROR,
    EDIT_JOBSPOT_PENDING,
} from "../../actions/jobspot/jobspot_action";

const initialState = {
    pending: false,
    pending_delete: false,
    error: null,
};

export function jobSpot(
    state = { ...initialState, jobSpotList: null },
    action
) {
    switch (action.type) {
        case JOBSPOT_LIST_PENDING:
            return {
                ...state,
                pending: true,
            };
        case JOBSPOT_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                jobSpotList: action.data,
            };
        case JOBSPOT_LIST_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error,
            };
        case DELETE_JOBSPOT_PENDING:
            return {
                ...state,
                pending_delete: true,
            }
        case DELETE_JOBSPOT_SUCCESS:
            return {
                ...state,
                pending_delete: false,
            }
        case DELETE_JOBSPOT_ERROR:
            return {
                ...state,
                pending_delete: false,
                error: action.error
            }
        default:
            return state;
    }
}



export const getJobSpotPending = (state) => state.pending;
export const getJobSpot = (state) => state.jobSpotList;
export const getJobSpotError = (state) => state.error;
export const deleteJobSpotPending = (state) => state.pending_delete;
export const deleteJobSpotError = (state) => state.error;